import TextCell from './Text';
import TextTwoValuesCell from './TextTwoValues';
import AvatarCell from './Avatar';
import DateCell from './Time';
import CurrencyCell from './Currency';
import ValuePercentageCell from './ValuePercentage/index';
import PercentageCell from './Percentage';
import BooleanCell from './Flag';
import NumberCell from './Digit';
import ToggleCell from './Toggle';

const cells = {
    textCell: TextCell,
    textTwoValuesCell: TextTwoValuesCell,
    avatarCell: AvatarCell,
    dateCell: DateCell,
    currencyCell: CurrencyCell,
    valuePercentageCell: ValuePercentageCell,
    percentageCell: PercentageCell,
    booleanCell: BooleanCell,
    numberCell: NumberCell,
    toggleCell: ToggleCell,
};

export default function Children(params) {
    const newParams = {
        ...params,
        ...params.childrenParams,
        value: params.childrenParams.field && params.data[params.childrenParams.field],
    };
    const newCell = params.childrenParams.cellRenderer && cells[params.childrenParams.cellRenderer];
    return newCell(newParams);
}
